import { render } from "./factoryComponent.vue?vue&type=template&id=50f1ebe4&scoped=true"
import script from "./factoryComponent.vue?vue&type=script&lang=js"
export * from "./factoryComponent.vue?vue&type=script&lang=js"

import "./factoryComponent.vue?vue&type=style&index=0&id=50f1ebe4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f1ebe4"]])

export default __exports__